import { useEffect, useState } from 'react';
import { useTenantConfig } from '../contexts';
import cosmicService from 'services/cosmic';
import { isVnpay } from 'helpers';

interface TermPolicy {
  slug: string;
  title: string;
}

interface Post extends TermPolicy {
  content: string;
}

export const useTermsAndPolicies = (): {
  termsAndPolicies: TermPolicy[];
  getPost: (slug: string) => Promise<Post>;
} => {
  const [termsAndPolicies, setTermsAndPolicies] = useState<TermPolicy[]>([]);

  const { partner, tenant } = useTenantConfig();

  const cosmicBucketName = partner && isVnpay(partner) ? 'vnpay' : tenant;

  const getPost = async (slug: string) => {
    return await cosmicService.getPost(slug, cosmicBucketName);
  };

  useEffect(() => {
    if (!cosmicBucketName) {
      return;
    }

    cosmicService.getSlugs(cosmicBucketName).then((slugs) => {
      setTermsAndPolicies(slugs);
    });
  }, [cosmicBucketName]);

  return { getPost, termsAndPolicies };
};
